<template>
  <div class="navigation pos-ab">
    <div class="container d-flex ali-c just-bet">
      <div class="logo-container d-flex ali-c">
        <img src="@/assets/logo.png" alt="logo" class="logo" loading="lazy">
      </div>
      <nav class="nav-btn d-flex ali-c just-ar">
        <router-link v-for="link in links" :key="link.path" :to="link.path" custom v-slot="{ isActive, navigate }"
          :exact="link.exact">
          <div class="d-flex ali-c just-start flex-column">
            <button @click="navigate" :aria-label="link.name" :class="['button-nav f-nor', { 'active': isActive }]">
              {{ link.name }}
            </button>
            <div class="circle" :class="{'cirAct':isActive}"></div>
          </div>
        </router-link>
      </nav>
      <img src="@/assets/images/googleBtn.webp" alt="googleBtn" class="googleBtn" @click="rediectTo" loading="lazy">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        { path: '/', name: 'Inicio', exact: true },
        { path: '/product', name: 'Préstamos' },
        { path: '/question', name: 'Ayuda' },
        { path: '/about', name: 'Sobre Nosotros' }
      ],
    }
  },
  methods: {
    rediectTo() {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.quick.fondo.prestamo.rapido.credito.dinero&hl=es-419&gl=mx'
    }
  }
}
</script>

<style lang="less" scoped>
@media (max-width: 768px) {
  .navigation {
    height: 10vw;
  }
  .container {
    height: 100%!important;
    .logo-container {
      justify-content: center;
      .logo {
        width: 7vw !important;
      }
    }
    .googleBtn {
      width: 20vw !important;
    }
  }
  .nav-btn {
    display: none !important;
  }

}
.navigation {
  width: 100%;
  z-index: 999;
  margin-top: 2vw;
  .container {
    height: 5vw;
    width: calc(100% - 6.25vw);
    background: #070710;
    margin: 0 auto;
    padding: 1.0417vw 2.5vw;
    border-radius: 4.1146vw;
    .logo-container {
      .logo {
        width: 2.5vw;
      }
    }

    .nav-btn {
      margin-top: 1vw;
      flex: 0.4;
      font-weight: 400;
      // margin-left: 3vw;
      .button-nav {
        color: #fff;
        font-size: 0.9375vw;
        font-weight: 400;
        text-align: center;
        cursor: pointer;

        // padding: 0 1.5625vw;
        margin: 0 1.5625vw;
        // height: 2.0833vw;
        line-height: 0.9375vw;
      }
      .active {
        color: #ff6625;
        font-size: 700;
      }
      .circle {
        margin-top: 0.6vw;
        width: 0.5208vw;
        height: 0.5208vw;
        border-radius: 50%;
        // background: #ff6625;
      }
      .cirAct {
        background: #ff6625;
      }
    }
    .googleBtn {
      width: 5.7292vw;
      cursor: pointer;
    }
  }
}
</style>
